define([
    'jquery',
    'lodash',

    'slick',
    'css!vendor/slick/slick.css',
    'css!vendor/slick/slick-theme.css'
], function(
    $,
    _
){
    function genDefaultOptions(){
        return {
            lazyLoad: 'ondemand',
            arrows: false,
            dots: true,
            autoplay: true,
            autoplaySpeed: 4000,
            // adaptiveHeight: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            fade: true,
            cssEase: 'linear'
        };
    }

    function genDefaultOptions2(){
        return {
            arrows: false,
            dots: true,
            autoplay: true,
            autoplaySpeed: 4000,
            // adaptiveHeight: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
        };
    }

    return {
        props: {
            options: {
                type: Object
            },
            images: {
                type: Array
            }
        },
        watch: {
            images: function () {

                console.log(this.images);

                this.destroySlick();
                this.$nextTick(function () {
                    this.initSlick();
                });
            }
        },
        data: function(){
            return {
                defaultOptions: genDefaultOptions(),
                defaultOptions2: genDefaultOptions2()

            };
        },
        computed: {
            fullOptions: function(){
                return _.assign({}, this.defaultOptions, this.options);
            },
            fullOptions2: function(){
                return _.assign({}, this.defaultOptions2, this.options);
            }
        },
        methods: {
            initSlick: function () {


                var optionReal = this.options&&this.options['slidesToShow']&&this.options['slidesToShow']>1?this.fullOptions2:this.fullOptions;

                $(this.$el).slick(optionReal)
                    .on('lazyLoaded', function (e, slick, image, imageSource) {

                        $(image).parent().css({
                            backgroundImage: 'url(' + imageSource + ')'
                        });
                    });
            },
            destroySlick: function () {
                $(this.$el).slick('unslick');
            },
            pause: function () {
                $(this.$el).slick('pause');
            },
            play: function () {
                $(this.$el).slick('play');
            },
        },
        mounted: function () {
            this.initSlick();
        },
        destroy: function () {
            this.destroySlick();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ../common/mixin/slick.js
// module id = 105
// module chunks = 2 3 7 8 12